import { DatePipe } from '@angular/common';
import { Component, ChangeDetectorRef, EventEmitter, Input, OnInit, OnChanges, SimpleChanges, Output, ViewChild, inject, DestroyRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { Permissions, Datazone, Attributes } from 'src/app/models/principal/permission';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { DataZone } from 'src/app/models/data-zone/data-zone';
import { SchedulerService } from 'src/app/services/api/scheduler.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import {AuthService} from 'src/app/services/auth/auth.service';
import { TenantService } from 'src/app/services/api/tenant.service';
import { EnvironmentTableComponent } from '../environment-table/environment-table.component';
import { EnvironmentPaginatorComponent } from '../environment-paginator/environment-paginator.component';
import { InstancesService } from 'src/app/services/api/instances.service';
import { SizingService } from 'src/app/services/api/sizing.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { translate } from '@jsverse/transloco';
import { ColumnFilterComponent } from '../../instances-mgmt/column-filter/column-filter.component';
import moment from 'moment';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { SizingConfirmDialogComponent } from 'src/app/components/sizing-confirm-dialog/sizing-confirm-dialog.component';
import { SizingDialogMode } from 'src/app/models/sizing';
import { RouterSegments } from 'src/app/models/router-segments';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { CloudProvider } from 'src/app/models/cloud-provider/cloud-provider';
import { AvailabilityStatus } from 'src/app/models/availability-status';

const REQUIRED_PERMISSIONS = [
  {
      key: PermissionKeys.SIZING_CREATE_NONPII,
      action: Permissions. SIZING_CREATE,
      attribute: Attributes.DATAZONE,
      attributeValue: Datazone.NONPII
   },
   {
      key: PermissionKeys.SIZING_CREATE_PII,
      action: Permissions. SIZING_CREATE,
      attribute: Attributes.DATAZONE,
      attributeValue: Datazone.PII
   },
   {
      key: PermissionKeys.SIZING_CREATE_LIVE,
      action: Permissions. SIZING_CREATE,
      attribute: Attributes.DATAZONE,
      attributeValue: Datazone.LIVE
   },
   {
      key: PermissionKeys.SIZING_READ_NONPII,
      action: Permissions.SIZING_READ,
      attribute: Attributes.DATAZONE,
      attributeValue: Datazone.NONPII
   },
   {
      key: PermissionKeys.SIZING_READ_PII,
      action: Permissions.SIZING_READ,
      attribute: Attributes.DATAZONE,
      attributeValue: Datazone.PII
   },
   {
      key: PermissionKeys.SIZING_READ_LIVE,
      action: Permissions.SIZING_READ,
      attribute: Attributes.DATAZONE,
      attributeValue: Datazone.LIVE
   }
]

@Component({
  selector: 'app-environment-sizing-documents',
  templateUrl: './environment-sizing-documents.html',
  styleUrl: './environment-sizing-documents.scss',
  standalone: false
})
export class EnvironmentSizingDocuments implements OnInit, OnChanges{
private destroyRef = inject(DestroyRef);
@ViewChild(EnvironmentPaginatorComponent) paginatorRef: EnvironmentPaginatorComponent;
@ViewChild(EnvironmentTableComponent) tableRef: EnvironmentTableComponent;
  @Input() data: any;
  @Output() updateEnvHeader = new EventEmitter<void>();
  @Output() sizingApplyStatusChange = new EventEmitter<boolean>();
  tenantId: string;
  sizingDocLoading = true;
  AvailabilityStatus = AvailabilityStatus;
  displayColumns = [
    {
      key: 'selected',
      name: '',
      type: 'radioSelection',
      sortable: false,
      visible: true,
      disable: false
    },
    {
      key: 'name',
      name: 'SIZING.DOCUMENTS',
      type: 'text',
      sortable: true,
      visible: true,
      disable: true,
      keyLink: 'popup'
    },
    {
      key: 'version',
      name: 'SIZING.SERVICE_DEFINITION_VERSION',
      type: 'text',
      visible: true,
      disable: false,
      sortable: true
    },
    {
      key: 'createdAt',
      name:  'INSTANCE_DETAILS.CREATED_DATE_UTC',
      type: 'date',
      visible: true,
      disable: false,
      sortable: true
    },
    {
      key: 'createdBy',
      name: 'RUNBOOK.CREATED_BY',
      type: 'userIcon',
      visible: true,
      disable: false,
      sortable: false
    },
    {
      key: 'applyAction',
      name: '',
      type: 'sizingApply',
      sortable: false,
      visible: true,
      disable: false
    },
    {
      key: 'action',
      name: 'RUNBOOK.ACTION',
      type: 'sizingDocAction',
      sortable: false,
      visible: true,
      disable: true
    },
    {
      key: 'sizingDocSettings',
      name: '',
      type: 'settings',
      visible: true,
      disable: true
    }
  ];

  showLoader = true;
  sizingDoc: any;
  sizingData:any;
  searchTerm: string = '';
  selectedData: any;
  pageName = 'sizingDoc';
  scheduleStatus: any;
  status: any;
  isAWS: boolean;
  searchedResult = [];
  isRefreshing = false;
  selectedVersion = [];
  date:any;
  instanceId: any;
  isFiltered = false;
  sizingDocResponse:boolean;
  apiNotFound = false;
  pageIndex = 0;
  paginationSize = 10;
  deployStatus = false;
  PermissionKeys = PermissionKeys;
  permissionsMap: { [key: string]: boolean; };
  isDataLoaded:boolean;
  dropdownsList: any;
  serviceDefVersion: any;
  filteredColumns: any;
  clearData: boolean;
  filterStartDate: any;
  filterEndDate: any;
  version: any;
  RouterSegments = RouterSegments;
  isCreateSizingAllowed: boolean;
  dataZone: any;
  isReadSizingAllowed: boolean;
  updateSizingAllowed: boolean;
  haveReadAccess: boolean;

  completedStatus = [DeployStatus.COMPLETED, DeployStatus.DEPLOYED, DeployStatus.UPDATED, DeployStatus.CONFIGURED, DeployStatus.TESTED];

  INSTANCE_DEPLOYED_STATES = [DeployStatus.DEPLOYED,DeployStatus.FAILED, DeployStatus.CONFIGURATION_FAILED, DeployStatus.CONFIGURED, DeployStatus.UPDATED, DeployStatus.TESTED, DeployStatus.UPDATE_FAILED, DeployStatus.TEST_FAILED];

  constructor(private activatedRoute: ActivatedRoute, public authService:AuthService,
    public schedulerService: SchedulerService, public sidenavService: SidenavService,
    private toastrService: CustomToastrService, public datePipe: DatePipe, public instanceService: InstancesService,
    public tenantService: TenantService, private cdr: ChangeDetectorRef, private sizingService: SizingService, private dialog: MatDialog, private router: Router, private permissionsService: PermissionsService ) {

  }

  ngOnInit(): void {
    this.instanceId = this.activatedRoute.snapshot.params.instanceId;
     if (localStorage.getItem('filteredSizingDocVersion')) {
      const userData = JSON.parse(localStorage.getItem('filteredSizingDocVersion'));
      if (userData) {
        this.selectedVersion = userData;
        this.serviceDefVersion = this.selectedVersion;
        this.dropdownsList?.[0]?.options?.forEach(element => {
          if(this.selectedVersion.find(item=> item === element.value)) {
            element.selected = true;
          }
        });
      }
    }
    if (localStorage.getItem('filteredCustomDate')) {
      const dateData = JSON.parse(localStorage.getItem('filteredCustomDate'));
      if (dateData) {
        this.date = dateData;
        this.dropdownsList?.[1]?.options?.forEach(element => {
          if(dateData.find(item=> item === element.value)) {
            element.selected = true;
          }
        });
      }
    }
    this.fetchSizingDoc();
    this.resetSizingDocFilter();
  }

  ngOnChanges(changes: SimpleChanges): void {
     this.tenantService.tenantData$.subscribe((data: any) => {
      this.isAWS = data === CloudProvider.AWS ? true : false;
    });
    if (changes['data'] && this.data?.dataZone) {
      this.dataZone = this.data.dataZone;
      this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
      this.isReadSizingAllowed = (this.permissionsMap[PermissionKeys.SIZING_READ_NONPII] && this.dataZone === Datazone.NONPII) || (this.permissionsMap[PermissionKeys.SIZING_READ_PII] && this.dataZone === Datazone.PII) || (this.permissionsMap[PermissionKeys.SIZING_READ_LIVE] && this.dataZone === Datazone.LIVE);
      this.haveReadAccess = this.isReadSizingAllowed;
      this.isCreateSizingAllowed = (this.permissionsMap[PermissionKeys.SIZING_CREATE_NONPII] && this.dataZone === Datazone.NONPII) || (this.permissionsMap[PermissionKeys.SIZING_CREATE_PII] && this.dataZone === Datazone.PII) || (this.permissionsMap[PermissionKeys.SIZING_CREATE_LIVE] && this.dataZone === Datazone.LIVE);
    }
  }

  get isAllowed(): boolean {
    return this.INSTANCE_DEPLOYED_STATES.includes(this.data?.status)
  }

  fetchSizingDoc(): void {
    this.showLoader = true;
    this.sizingDocLoading = true;

    this.sizingService.getSizingDocs(this.instanceId)
    .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(response => {
        response = response?.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
        this.sizingDocLoading = false;
        this.sizingDoc = response;
        this.sizingData = this.sizingDoc;
        this.showLoader = false;
       this.instanceService.getInstanceById(this.instanceId)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((data: any) => {
          const instanceSizingDocId = data?.sizingDocumentId;

          const parseVersion = (name: string): { major: number; minor: number } | null => {
            const match = name?.match(/_v(\d+)\.(\d+)$/i);
            return match ? { major: parseInt(match[1], 10), minor: parseInt(match[2], 10) } : null;
          };

          const appliedDoc = this.sizingDoc?.find(doc => doc.id === instanceSizingDocId);
          const appliedVersion = appliedDoc ? parseVersion(appliedDoc.name) : null;
          const isInstanceDeployed = this.INSTANCE_DEPLOYED_STATES.includes(data?.status)
          

          this.sizingDoc = this.sizingDoc?.map(doc => {
            const docVersion = parseVersion(doc.name);
            const isLowerVersion = appliedVersion && docVersion
              ? (docVersion.major < appliedVersion.major || (docVersion.major === appliedVersion.major && docVersion.minor < appliedVersion.minor))
              : false;
            return {
              ...doc,
              isApplied: doc.id === instanceSizingDocId,
              isLowerVersion,
              isInstanceDeployed
            };
          });

        this.sizingData = this.sizingDoc;
        });
        this.showLoader = false;
        this.sizingDoc.length > 0 ? this.sizingDocResponse=true: this.sizingDocResponse = false;
        this.deployStatus = this.sizingDoc.some(item => item.status === 'deploying' || item.status === 'configuring');
        this.initializeFilterItems();
      },
       (error) => {
        this.showLoader = false;
        if (error.httpStatusCode === 404){
          this.apiNotFound = true;
        } else {
        this.initializeFilterItems();
        setTimeout(() => {
          const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      }
      });
  }

  search(searchTerm?: string): void {
    this.searchTerm = searchTerm;
  }

   onPageChange(event) {
    this.paginationSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.tableRef?.pageChanged(event);
   }

  onTablePageChanged(event) {
    this.pageIndex = event.pageIndex;
    this.paginationSize = event.pageSize;
  }


  refreshClick(): void {
    this.isRefreshing = true;
    this.sizingDocLoading = true;
  if (this.isFiltered) {
    setTimeout(() => {
      this.isRefreshing = false;
      this.sizingDocLoading = false;
    }, 1000);
    return;
  }

  if (this.paginatorRef) {
    this.paginatorRef.pageIndex = 0;
  }

  this.fetchSizingDoc();

  setTimeout(() => {
    this.isRefreshing = false;
    this.sizingDocLoading = false;
  }, 1000);
  }

  searchedItems(result): void {
    this.searchedResult = result;
    this.cdr.detectChanges();
  }


   resetPaginator() {
     this.pageIndex = 0;
     this.paginatorRef.pageIndex = 0;
  }

    initializeFilterItems(){

    this.version = Array.from(
      new Set(this.sizingData?.map((item) => item.version || '-'))).filter((version) => version && version !== '-').map((version) => ({
        value: version,
        label: version,
        selected: false,
      }));

     const createdDate = [
      {value: 'Created Date', selected: false}
    ];

    this.dropdownsList = [
      {
        title: 'Version',
        placeholder: 'Select Version',
        options: this.version
      },
      {
        title: 'Date',
        placeholder: 'Select Date',
        options: createdDate
      }
    ];


}


  /* Cleares the selected Status filter */
  cancelVersionFilter(data) {
    let selectedItem = this.selectedVersion.indexOf(data);
    if (selectedItem > -1) {
      localStorage.removeItem('filteredSizingDocVersion');
      this.selectedVersion.splice(selectedItem, 1);
      this.dropdownsList[0].options.find(item => item.value === data).selected = false;
      localStorage.setItem('filteredSizingDocVersion', JSON.stringify(this.selectedVersion));
      this.filterSizingDocItems(this.filteredColumns);
    }
  }

   filterColumns(): void {

      if(this.serviceDefVersion) {
        this.dropdownsList[0].options.filter((item) => {
          if (this.serviceDefVersion?.find(version => version === item.value)) {
            item.selected = true;
          }
        });
      }
       if(this.date) {
        this.dropdownsList[1].options.filter((item) => {
          if (item.value === this.date) {
            item.selected = true;
          }
        });
      }
      const data = {
        name: translate('SIZING.SIZING_DOCUMENTS'),
        title: translate('INSTANCE_STATUS.FILTER_TITLE'),
        subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
        filteredColumns: this.dropdownsList,
        dateCreated: this.data?.dateCreated,
        serviceDefVersionList: this.dropdownsList?.[0].options,
        filterOptions: this.dropdownsList?.[1].options,
        startDateTest: this.dropdownsList?.[1].options?.[0]?.selected ? moment(this.filterStartDate) : '',
        endDateTest: this.dropdownsList?.[1].options?.[0]?.selected ? moment(this.filterEndDate) : '',
        sizingDocColumns: [
          'version',
          'date'
        ]
      };
      this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(filteredColumns => {
        this.filteredColumns = filteredColumns;
        if (filteredColumns) {
          this.isFiltered = true;
          this.clearData = true;

          if(filteredColumns[0] !== '') {
            this.serviceDefVersion = filteredColumns[0];
          }
          if(filteredColumns[1] !== '') {
            localStorage.removeItem('filteredSizingDocDate');
            this.date = filteredColumns[1];
            localStorage.setItem('filteredSizingDocDate', JSON.stringify(filteredColumns[1]));
          }
           if (filteredColumns[0]?.length === 0 && filteredColumns[1]?.length === 0){
            this.resetSizingDocFilter();
          } else {
            this.filterSizingDocItems(filteredColumns);
          }
        }
      });
    }

    /* Reset the selected sizing doc filter */
  resetSizingDocFilter(): void {
    this.isFiltered = false;
    this.selectedVersion = [];
    this.sidenavService.searchFilter.next('data');
    this.dropdownsList?.[0]?.options?.filter((item) => {item.selected = false});
    this.dropdownsList?.[1]?.options.filter((item) => {item.selected = false});
    this.serviceDefVersion = undefined;
    this.date = undefined;
    this.filterStartDate = undefined;
    this.filterEndDate = undefined;
    this.sizingData = this.sizingDoc;
    localStorage.removeItem('filteredSizingDocVersion');
    localStorage.removeItem('filteredSizingDocDate');
    localStorage.removeItem('filteredSizingDocStartDate');
    localStorage.removeItem('filteredSizingDocEndDate');
  }

    /* Returns a label for the Version */
  getVersionLabel(version): void {
            return this.selectedVersion?.find(item => item?.value === version)?.label || version || '';

  }


    filterSizingDocItems(filteredColumns): void {
      if (filteredColumns) {
        this.sizingData = this.sizingDoc;
        this.selectedVersion = [];
        if (filteredColumns[0]?.length > 0) {
          this.selectedVersion = filteredColumns[0];
          if (filteredColumns[0].length > 0) {
            localStorage.setItem('filteredSizingDocVersion', JSON.stringify(this.selectedVersion));
            this.sizingData = this.sizingData?.filter(item => this.selectedVersion?.includes(item?.version));
          } else {
            localStorage.removeItem('filteredSizingDocVersion');
          }
        }
        if (this.dropdownsList[1].options[0].selected && moment(filteredColumns[1][1].filteredStartDate).isValid() && moment(filteredColumns[1][1].filteredEndDate).isValid()) {
          this.filterStartDate = filteredColumns[1][1].filteredStartDate;
          this.filterEndDate = filteredColumns[1][1].filteredEndDate;
          localStorage.setItem('filteredSizingDocStartDate', this.filterStartDate);
          localStorage.setItem('filteredSizingDocEndDate', this.filterEndDate);

          const startDateUTC = moment.utc(moment(this.filterStartDate).format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day');
          const endDateUTC = moment.utc(moment(this.filterEndDate).format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day');
          this.sizingData = this.sizingData?.filter(item => {
            const itemDateUTC = moment.utc(item.updatedAt).startOf('day');
            return itemDateUTC.isSameOrAfter(startDateUTC) && itemDateUTC.isSameOrBefore(endDateUTC);
          });

        } else {
          this.filterStartDate = undefined;
          this.filterEndDate = undefined;
          localStorage.removeItem('filteredSizingDocStartDate');
          localStorage.removeItem('filteredSizingDocEndDate');
        }
      }
    }

     /* Cleares the selected Date filter */
  cancelSizingDocDateFilter() {
    this.filterStartDate = undefined;
    this.filterEndDate = undefined;
    this.dropdownsList?.[1]?.options?.filter((item) => {item.selected = false});
    this.date?.forEach(element => {
      if(element.includes(this.dropdownsList[1].options[0].value)) {
        this.date.pop(element);
      }
    });

    localStorage.removeItem('filteredSizingDocStartDate');
    localStorage.removeItem('filteredSizingDocEndDate');
    localStorage.removeItem('filteredCustomDate');
    localStorage.removeItem('filteredSizingDocDate');
    this.filterSizingDocItems(this.filteredColumns);
  }

  /* Handles the Create button click event */
  createClick(): void {
    const appliedDoc = this.sizingDoc?.find(doc => doc.isApplied);

    if (!appliedDoc) return;

    const dialogRef = this.dialog.open(SizingConfirmDialogComponent, {
      width: '566px',
      height: '400px',
      disableClose: true,
      data: {
        documentName: appliedDoc.name,
        environmentSize: appliedDoc?.environmentSize,
        mode: SizingDialogMode.CREATE_WITH_EXISTING
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) return;
      this.navigateSizing();
    });
}

/* Navigates the user to the Create Sizing workflow */
    navigateSizing(): void {
        this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT , this.data?.tenantId, RouterSegments.BLUEPRINTS, this.activatedRoute.snapshot.params.blueprintId,
        RouterSegments.ENVIRONMENT, this.activatedRoute.snapshot.params.instanceId, RouterSegments.SIZING], {state: {sizingDocData: this.sizingDoc}});
    }

  // Applying the sizing document
  applySizing(data: any): void {
  //   this.dialog.open(ConfirmationDialogComponent, {
  //     panelClass: 'default-dialog-wrapper',
  //     width: '566px',
  //     autoFocus: false,
  //     data: {
  //       title: translate('SIZING.SIZING_DOCUMENT'),
  //       message: translate('SIZING.CONFIRMATION'),
  //       page: 'sizingApply',
  //       ticketIdField: true,
  //       noteSizing: true,
  //       note: translate('SIZING.NOTE'),
  //       confirmButtonText: translate('BUTTONS.CONFIRM')
  //     }
  // })
  this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('SIZING.APPLY_SIZING_DOCUMENT'),
        message: translate('SIZING.APPLY_CONFIRMATION'),
        confirmButtonText: translate('BUTTONS.APPLY')
      }
    })
    .afterClosed()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(confirm => {
      if (confirm) {
        this.sizingService.applySizingDocId(this.instanceId, data.id)
        .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((res) => {
            if (res?.httpStatusCode === 202) {
              this.fetchSizingDoc();
              this.updateEnvHeader.emit();
              this.sizingApplyStatusChange.emit(true);
                setTimeout(() => {
                const title = translate('SCHEDULES.APPLY_SIZING_HEADER');
                const message = translate('SCHEDULES.SIZING_APPLY');
                  this.toastrService.successMessage(message, title);
                }, 500);
              }
            },
          (error) => {
            const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
          this.dialog.open(ErrorDialogComponent, {
            minHeight: '342px',
            width: '630px',
            panelClass: 'flex-dialog',
            data: {
              title:  translate('ERROR_DIALOG.APPLY_SIZING_DOC_FAILED'),
              description: errorMessage
            }
          });
        });
      }
    });
  }

  // Deleting the sizing document
  deleteSizing(data): any {
        this.dialog.open(ConfirmationDialogComponent, {
          panelClass: 'default-dialog-wrapper',
          width: '566px',
          autoFocus: false,
          data: {
            title: translate('INSTANCE_DETAILS.SIZING_TITLE'),
            message: translate('INSTANCE_DETAILS.SIZING_MESSAGE'),
            confirmButtonText: translate('BUTTONS.DELETE')
          }
        })
          .afterClosed()
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(confirm => {
            if (confirm) {
              this.sizingService.deleteSizingDocsBySizingId(this.instanceId, data.id)
                .pipe(
                  takeUntilDestroyed(this.destroyRef))
                .subscribe((res) => {
                  if (res?.httpStatusCode === 204) {
                    this.fetchSizingDoc();
                      setTimeout(() => {
                      const title = translate('SCHEDULES.SIZING');
                        const message = translate('SCHEDULES.SIZING_DELETE_SUCCESS');
                        this.toastrService.successMessage(message, title);
                      }, 500);
                    }
                    },
          (error) => {
            const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
          this.dialog.open(ErrorDialogComponent, {
            minHeight: '342px',
            width: '630px',
            panelClass: 'flex-dialog',
            data: {
              title:  translate('ERROR_DIALOG.DELETE_SIZING_DOC_FAILED'),
              description: errorMessage
            }
          });
        });
      }
    });
  }

  // Editing the sizing document
  editSizing(data): any {
      this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT , this.data?.tenantId, RouterSegments.BLUEPRINTS, this.activatedRoute.snapshot.params.blueprintId,
        RouterSegments.ENVIRONMENT, this.activatedRoute.snapshot.params.instanceId, RouterSegments.SIZING, data?.id], {
      state: {
        sizingTableData: data?.id
      }
    }
  );
  }
}
